import ApplicationAdapter from '../../application';

export default class Base extends ApplicationAdapter {
  namespace = 'providers/au/sif/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('sif/au/', '')
      .toLowerCase();
  }
}
